import { IonCard, IonCardContent, IonCardHeader } from "@ionic/react";
import { ComponentProps, ReactNode } from "react";

import styles from "@components/cards/CardBase.module.css";
import { Colors } from "@utils/colorUtils";

type Props = Omit<ComponentProps<typeof IonCard>, "button" | "children" | "color"> & {
  body: ReactNode;
  color?: Colors;
  header?: ReactNode;
  image?: JSX.IntrinsicElements["img"];
};

const CardBase = ({ body, className, color = "white", header, image, ...ionCardProps }: Props) => {
  const classNames = [styles.card];
  if (className) classNames.push(className);

  const isButton = ionCardProps.routerLink === undefined && ionCardProps.onClick !== undefined;

  return (
    <IonCard {...ionCardProps} button={isButton} className={classNames.join(" ")} color={color}>
      {image && <img {...image} />}
      {header && <IonCardHeader>{header}</IonCardHeader>}
      <IonCardContent>{body}</IonCardContent>
    </IonCard>
  );
};

export default CardBase;
